import React from 'react';
import { Zap, Shield, Lock, Headphones, Rocket } from 'lucide-react';

const ProductCTA = ({ onPurchase }) => {
 const guarantees = [
 {
 icon: <Zap className="w-6 h-6" />,
 title: 'Instant Access',
 description: 'ChatGPT Plus ready in 5 minutes'
 },
 {
 icon: <Shield className="w-6 h-6" />,
 title: 'Bank-Level Security',
 description: '256-bit SSL & secure processing'
 },
 {
 icon: <Lock className="w-6 h-6" />,
 title: 'Complete Data Isolation',
 description: 'Zero cross-contamination'
 },
 {
 icon: <Headphones className="w-6 h-6" />,
 title: '24/7 Support & Monitoring',
 description: 'Always available assistance'
 }
 ];

 const handlePurchase = () => {
 onPurchase('default');
 };

 return (
 <section className="py-20 bg-black text-white">
 <div className="container mx-auto px-4 text-center">
 <div className="max-w-4xl mx-auto">
 {/* Main Title */}
 <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
 Ready to Access the Latest AI Models at 65% Less Cost?
 </h2>
 
 {/* Subtitle */}
 <p className="text-xl mb-12 opacity-90 max-w-2xl mx-auto">
 Join thousands of users who've already upgraded to premium AI access
 </p>
 
 {/* Main CTA Button */}
 <button
 onClick={handlePurchase}
 className="bg-white text-black px-12 py-6 rounded-2xl text-xl font-semibold hover:bg-cream-100 transition-colors duration-200 inline-flex items-center justify-center space-x-3 mb-16 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
 >
 <Rocket className="w-6 h-6" />
 <span>Get ChatGPT Plus Access Now - $8.99/month</span>
 </button>
 
 {/* Guarantees Grid */}
 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-5xl mx-auto mb-12">
 {guarantees.map((guarantee, index) => (
 <div key={index} className="bg-white bg-opacity-10 rounded-2xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 transition-colors duration-200">
 <div className="text-white mb-4 flex justify-center">
 {guarantee.icon}
 </div>
 <h3 className="font-semibold mb-2 text-lg">{guarantee.title}</h3>
 <p className="text-sm opacity-80 leading-relaxed">{guarantee.description}</p>
 </div>
 ))}
 </div>
 
 {/* Risk Reversal */}
 <div className="bg-white bg-opacity-10 rounded-2xl p-8 border border-white border-opacity-20 max-w-2xl mx-auto">
 <h3 className="text-2xl font-semibold mb-4 text-white">
 30-Day Money-Back Guarantee
 </h3>
 <p className="text-lg opacity-90 leading-relaxed">
 Don't love it? Get every penny back, no questions asked. We're confident you'll see 
 immediate value from day one, but if you're not completely satisfied, we'll refund 
 your full payment within 30 days.
 </p>
 </div>

 {/* Additional Trust Elements */}
 <div className="mt-16 pt-8 border-t border-white border-opacity-20">
 <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
 <div className="text-center">
 <div className="text-3xl font-bold mb-2">50,000+</div>
 <p className="text-sm opacity-80">Satisfied customers worldwide</p>
 </div>
 <div className="text-center">
 <div className="text-3xl font-bold mb-2">99.9%</div>
 <p className="text-sm opacity-80">Service uptime guaranteed</p>
 </div>
 <div className="text-center">
 <div className="text-3xl font-bold mb-2">4.9/5</div>
 <p className="text-sm opacity-80">Average customer rating</p>
 </div>
 </div>
 </div>

 {/* Final CTA */}
 <div className="mt-12">
 <p className="text-lg opacity-90 mb-6">
 Don't wait - prices may increase as demand grows
 </p>
 <button
 onClick={handlePurchase}
 className="bg-white text-black px-10 py-4 rounded-2xl text-lg font-semibold hover:bg-cream-100 transition-all duration-200 transform hover:-translate-y-1 hover:shadow-xl"
 >
 Start Your AI Journey Today →
 </button>
 </div>
 </div>
 </div>
 </section>
 );
};

export default ProductCTA;